import { PlayerStatus } from '@tunein/web-player-manager';

export const legacyPlayerStatuses = {
  idle: 'idle',
  playing: 'playing',
  paused: 'paused',
  stopped: 'stopped',
  connecting: 'connecting',
  loading: 'loading',
  failed: 'failed',
  popout: 'popout',
  waiting: 'waiting',
};

export const playerStatuses = {
  [legacyPlayerStatuses.idle]: PlayerStatus.IDLE,
  [legacyPlayerStatuses.playing]: PlayerStatus.PLAYING,
  [legacyPlayerStatuses.loading]: PlayerStatus.LOADING,
  [legacyPlayerStatuses.waiting]: PlayerStatus.WAITING,
  [legacyPlayerStatuses.failed]: PlayerStatus.FAILED,
  // DEPRECATE
  [legacyPlayerStatuses.connecting]: PlayerStatus.LOADING,
  [legacyPlayerStatuses.paused]: PlayerStatus.IDLE,
  [legacyPlayerStatuses.stopped]: PlayerStatus.IDLE,
  // Player Manager doesn't have a Popout player state. Instead, we're relying on signals from the error event to maintain
  // a popout state in the player store.
  [legacyPlayerStatuses.popout]: legacyPlayerStatuses.popout,
};
